import { useQuery } from '@tanstack/react-query';
import { call } from '@/lib/api';

export type CallDisposition = 'answered' | 'missed';
export type CallRecordingStatus = 'none' | 'pending' | 'available' | 'failed';

export type Call = {
  id: number;
  leadId: number | null;
  contactId: number | null;
  direction: 'inbound';
  disposition: CallDisposition;
  callerPhone: string;
  calledPhone: string | null;
  answeredByUserId: number | null;
  answeredByEmail: string | null;
  answeredByInfo: { name?: string; picture?: string } | null;
  durationSeconds: number | null;
  recordingStatus: CallRecordingStatus;
  createdAt: string;
};

export const callKeys = {
  all: ['calls'] as const,
  list: (target: { leadId?: number; contactId?: number }) =>
    [...callKeys.all, 'list', target] as const,
};

const callGet = <T>(endpoint: string, json?: any): Promise<T> =>
  call<T>(endpoint, { method: 'GET', json }).then((r) => r.json());

export function useCallsList(target: { leadId?: number; contactId?: number }) {
  return useQuery({
    enabled: target.leadId != null || target.contactId != null,
    queryKey: callKeys.list(target),
    queryFn: () => callGet<{ calls: Call[] }>('calls/list', target),
    refetchInterval: (query) =>
      query.state.data?.calls.some((c) => c.recordingStatus === 'pending')
        ? 30_000
        : false,
  });
}

export const fetchRecordingUrl = (id: number) =>
  callGet<{ url: string }>('calls/recording-url', { id });
